import React from "react";
import { ButtonVariant } from "../../../components/atoms/ButtonVariant";
import { useRemoveBillingOwnerDialog } from "../../../components/organisms/accounts/useRemoveBillingOwnerDialog";

export const RemoveBillingOwnerButton = ({
  billingOwnerId,
  accountId,
}: {
  billingOwnerId: string;
  accountId: string;
}) => {
  const removeBillingOwnerPrompt = useRemoveBillingOwnerDialog({ accountId });

  const handleClick = () => removeBillingOwnerPrompt(billingOwnerId);

  return (
    <ButtonVariant
      content="Remove Billing Owner"
      color="darkRed"
      onClick={handleClick}
    />
  );
};
